module.exports = __webpack_public_path__ + "img/larrykingbettervert.e387d245.webp";